import { identityActions, localStore, resourceActions, setDictionary, setLanguage } from '../../services';
import { extractDataFromJwt } from '../../util';
let storedState = localStorage.getItem( 'resources' )|| {};
if (typeof storedState === 'string' && storedState!=="undefined")
{ storedState=JSON.parse(storedState)}
else
{ 
  storedState={}
}


export const resourceReducer = ( state = storedState || {}, action ) => {
  switch ( action.type ) {
    case identityActions.LOAD:
      const language = localStore.get( 'language' );
      const payload = extractDataFromJwt( action.data );
      setLanguage( language || payload.content.culture  );
      return state;
    case resourceActions.LOAD:
      localStorage.setItem('resources', JSON.stringify(action.resources));
      setDictionary( action.resources?.translations );
      return action.resources;
    default:
      return state;
  }
};
